<div class="w-100 h-100 d-flex align-items-stretch py-2 bg-white plannerContainer">
  @for (lesson of lessons; track lesson.date || $index; let i = $index) {
    <article
      id="lessonDay{{ i }}"
      class="lessonDayPlan d-flex flex-column justify-content-start align-items-start my-2"
      [draggable]="(!lesson.isSkipDay && isEditable) || null"
      zbpDroppable
      [dropEnabled]="isDayDroppable(lesson)"
      [class.lessonDayPlanDroppable]="isDayDroppable(lesson)"
      [class.lessonDayPlanSkipped]="lesson.isSkipDay || !lesson.topicKey"
      (dragstart)="lessonDragged($event, lesson)"
      (dragend)="lessonDragCanceled()"
      (drop)="lessonDropped($event, lesson)">
      <header class="lessonDayHeader w-100 d-flex flex-wrap flex-column justify-content-center align-items-center p-2">
        <div class="w-100 text-center">
          <h3 class="lessonDayOfWeek text-uppercase my-0 py-2 h6 d-inline-block">{{ lesson.dayOfTheWeek }}</h3>
        </div>
        <time class="lessonDayDate fst-italic" [attr.datetime]="lesson.date">{{ lesson.formattedDate }}</time>
        <h4 id="lessonDayHeading{{ i }}" class="lessonDayHeading my-0 ms-auto">
          @if (lesson.isSkipDay || !lesson.topicKey) {
            <span>No Lesson</span>
          } @else {
            <span>
              <p class="mb-0 lessonDayHeadingUnit">{{ lesson.unitName }}</p>
              <p class="mb-0 lessonDayHeadingTopic">{{ lesson.topicName }}</p>
            </span>
          }
        </h4>
        @if (isEditable) {
          <nav ngbDropdown class="lessonOptionsMenu">
            <button
              id="lessonOptionsButton{{ i }}"
              tabindex="0"
              class="btn btn-sm lessonOptionsButton buttonIcon d-print-none"
              ngbDropdownToggle
              [attr.aria-label]="'Options'">
              <i class="fa fa-ellipsis" aria-hidden="true"></i>
            </button>
            <div class="lessonOptionsDropdownContainer">
              <ul ngbDropdownMenu [attr.aria-labelledby]="'lessonOptionsButton' + i ">
                <li class="ps-0">
                  <button
                    id="lessonToggleButton{{ i }}"
                    tabindex="0"
                    class="dropdown-item--tertiary"
                    type="button"
                    ngbDropdownItem
                    ngbTooltip="Shifts the lesson on this day to the following day or restores the following lesson back to this day."
                    placement="top"
                    tooltipClass="tooltip-tertiary"
                    (click)="toggleSkipDay(lesson)">
                    {{ lesson.isSkipDay ? 'Restore' : 'Skip' }} {{ lesson.dayOfTheWeek }}
                  </button>
                </li>
                @if (!lesson.isSkipDay && !!lesson.topicKey) {
                  <li class="ps-0">
                    <button
                      id="lessonExtendButton{{ i }}"
                      tabindex="0"
                      class="dropdown-item--tertiary"
                      type="button"
                      ngbDropdownItem
                      ngbTooltip="Extends this lesson to the following day or next available day."
                      placement="top"
                      tooltipClass="tooltip-tertiary"
                      (click)="stretchLesson(lesson, 'AddStretchedLesson')">
                      Extend by 1 Day
                    </button>
                  </li>
                }
                @if (!lesson.isSkipDay && !!lesson.topicKey && lesson.lessonHasMultipleDays) {
                  <li class="ps-0">
                    <button
                      id="lessonShortenButton{{ i }}"
                      tabindex="0"
                      class="dropdown-item--tertiary"
                      type="button"
                      ngbDropdownItem
                      ngbTooltip="Shortens this lesson by one day."
                      placement="top"
                      tooltipClass="tooltip-tertiary"
                      (click)="stretchLesson(lesson, 'ReduceStretchedLesson')">
                      Shorten by 1 Day
                    </button>
                  </li>
                }
              </ul>
            </div>
          </nav>
        }
      </header>
      <div class="lessonDayContent w-100 h-100">
        @for (tab of lesson.tabs; track tab; let n = $index) {
          <h5 class="h6 fw-normal text-uppercase lessonPlanSectionHeading">{{ tab.name }}</h5>
          <ul id="lessonPlanStepList{{ i }}_{{ n }}" class="my-2 lessonPlanStepList">
            @for (stepGroup of tab.section.stepCollections; track stepGroup; let x = $index) {
              @for (step of stepGroup.steps; track step; let a = $index) {
                <li id="lessonPlanStepListItem_{{ i }}_{{ n }}_{{ x }}_{{ a }}" class="lessonPlanStepListItem">
                  <h6 class="lessonPlanStepHeading my-0" [innerHTML]="renderInline(step.header)"></h6>
                  <div class="lessonPlanStepSubHeading" [innerHTML]="renderInline(step.subHeader)"></div>
                </li>
              }
            }
          </ul>
        }
      </div>
    </article>
  }
</div>
<section class="w-100 my-3 lessonPlanStandardsContainer">
  <div ngbAccordion #lessonPlanStandards="ngbAccordion" activeIds="lessonPlanStandardsPanel" type="tertiary">
    <div ngbAccordionItem class="panel-parent" ngbAccordionItem="lessonPlanStandardsPanel">
      <div ngbAccordionHeader>
        <button ngbAccordionButton>
          <div class="d-flex no-gutters justify-content-between align-items-baseline">
            <h2 class="h5 text-white m-0">View standards covered in these lessons</h2>
            <i class="d-block fa" [ngClass]="getChevronClass(lessonPlanStandards)" aria-hidden="true"></i>
          </div>
        </button>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <aside class="w-100 d-flex flex-wrap justify-content-start align-items-start py-4 px-3 ">
              <div class="lessonPlanStandardsSectionsContainer d-flex flex-column justify-content-start align-items-start">
              </div>
              <nav class="d-print-none align-self-end ms-auto">
                <button id="printButton" type="button" class="btn btn-md skButton text-uppercase px-3" (click)="printPlan()">Print</button>
              </nav>
            </aside>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</section>
